import { Injectable } from '@angular/core';

import { BreadcrumbItem } from '@mitsubishi/shared/ui';

import { Dispatch } from '@ngxs-labs/dispatch-decorator';
import { Store } from '@ngxs/store';

import { SetBreadcrumbs } from './breadcrumbs.actions';
import { ProjectBreadcrumbsSelectors } from './breadcrumbs.selectors';

@Injectable({
  providedIn: 'root',
})
export class ProjectBreadCrumbsFacade {
  breadcrumbs$ = this.store.select(ProjectBreadcrumbsSelectors.getProjectBreadCrumbs);
  breadcrumbs = this.store.selectSignal(ProjectBreadcrumbsSelectors.getProjectBreadCrumbs);

  constructor(private readonly store: Store) {}

  @Dispatch()
  setBreadcrumbs(breadcrumbs: BreadcrumbItem[]) {
    return new SetBreadcrumbs(breadcrumbs);
  }
}
